<template>
	<modal v-if="data" @close="close">
		<template slot="title">Handelsbetingelser</template>
		<template slot="text">
			<vHtml :markdown="data.content"/>
		</template>
	</modal>
</template>

<script>
import modal from "@/components/modal.vue";
import vHtml from "@/components/html.vue";

export default {
	components: {modal, vHtml},
	data() {
		return {
			data: null
		}
	},
	methods: {
		async getData() {
			const {data: {data}} = await this.$axios.get(`client/pages/terms`);
			this.data = data;
		},
		close() {
			this.$emit("close");
		}
	},
	created() {
		this.getData();
	}
};
</script>

<style lang="scss" scoped>
.terms {

}
</style>
